import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { BsCardChecklist, BsUpload, BsGraphUp } from "react-icons/bs";
import moment from "moment";
import { BiRefresh } from "react-icons/bi";
import { theme } from "../../utils/theme";
import { toast } from "react-toastify";
import Loader from "./../../components/Popups/Loader";
import { getCurrentUser } from "../../services/UserService"
import { getTeamAdmins, getReport } from "../../services/ReportService";
import { Typography } from "@mui/material";
import { Chart } from "react-google-charts";
import ReportTable from "./ReportTable";

const Reports = () => {
  const [tab, setTab] = useState(1);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { userData } = useSelector((state) => state.authReducer);
  
  const [isLoading, setIsLoading] = useState(false);
  const [teamId, setTeamId] = useState("");
  const [taskStatus, setTaskStatus] = useState("");
  const [reportList, setReportList] = useState([]);
  const [teamAdminList, setTeamAdminList] = useState([]);
  const [taskStats, setTaskStats] = useState({
    task_count: 0,
    task_completed_count: 0,
    // task_deleted_count: 0,
    task_incomplete_count: 0
  });
  const [taskStatsConfig, setTaskStatsConfig] = useState({
    task_count: "Total Tasks",
    task_completed_count: "Completed Tasks",
    // task_deleted_count: "Deleted Tasks",
    task_incomplete_count: "Incompleted Tasks",
  });
  const [pieChartData, setPieChartData] = useState([]);
  const [pieChartOptions, setPieChartOptions] = useState({
    title: "Tasks",
    is3D: true,
    slices: {0:{color: 'blue'}, 1:{color: '#ff9900'}}
  });
  
  const fetchReports = () => {
    let params = {}
    if(teamId != ""){
      params["team_id"] = teamId
    }
    if(taskStatus != ""){
      params["task_status"] = taskStatus
    }
    setIsLoading(true);
    getReport(params, (response) => {
      setIsLoading(false);
      let reportData = response.data;
      let task_count = reportData?.task_count || 0;
      let task_completed_count = reportData?.task_done_count || 0;
      let task_deleted_count = reportData?.task_deleted_count || 0;
      let task_incomplete_count = reportData?.task_incomplete_count || 0;
      let reportList = reportData?.all_tasks || [];
      setReportList(reportList)
      let tempTaskStats = {
        task_count, task_completed_count, task_deleted_count, task_incomplete_count
      }

      let tempChartData = Object.keys(taskStatsConfig).filter((row) => { return row != "task_count"; }).map((item) => { return [taskStatsConfig[item], tempTaskStats[item]] });
      
      setPieChartData(
        [
          ["Task Status", "Count"],
          ...tempChartData
        ]
      )
      setTaskStats(tempTaskStats);
    })
  }
  
  useEffect(() => {
    getTeamAdmins((response) => {
      setTeamAdminList(response.data);
    });
    fetchReports();
  }, []);
  return (
    <div className="overflow-x-hidden">
      <Loader isLoading={isLoading} />
      <div className="3xl:text-3xl text-2xl font-medium flex items-center gap-[10px]">
        Reports
      </div>
      <div className="my-[10px]">
        Performance Reports
      </div>
      <hr className="mb-2"></hr>
      <div className="flex gap-[20px] justify-between items-center md:w-1/2 lg:w-1/2 sm:w-full">
          <div className="items-center w-1/2">
            <select
              value={teamId}
              onChange={(e) => {
                setTeamId(e.target.value);
              }}
              className="block appearance-none w-full transition bg-white border border-[#07457f] text-[#07457f] py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            >
              <option value={""}>
                  Select Team Admin
              </option>
              {teamAdminList.map((item) => (
                <option key={item.team_id} value={item.team_id}>
                  {item.user_name}
                </option>
              ))}
            </select>
          </div>
          {/* <div className="items-center w-1/3">
            <select
              value={taskStatus}
              onChange={(e) => {
                setTaskStatus(e.target.value);
              }}
              className="block appearance-none w-full transition bg-white border border-[#07457f] text-[#07457f] py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            >
              <option value={""}>Select Task Status</option>
              <option value={"task_done"}>Completed</option>
              <option value={"task_done"}>Done</option>
              <option value={"task_deleted"}>Deleted</option>
            </select>
          </div> */}
          <div className="items-center w-1/2">
            <div className="my-[10px] font-medium text-black rounded-md  p-[5px] text-center cursor-pointer border-2 border-[#07457F] hover:border-sky-500" onClick={(e) => { fetchReports(); }}>
              Submit
            </div>
          </div>
      </div>
      {tab === 1 && (
        <>
        <div className="flex md:flex-row lg:flex-row sm:flex-col xs:flex-col">
            <div className="s12-p1-step border p-[5px] transition rounded-md my-[10px] md:w-1/3 lg:w-1/3 sm:w-full float-left">
                <div className="flex flex-wrap items-center">
                    {
                        Object.keys(taskStatsConfig).map((task, index) => {
                          return (
                            <div className="bg-white border rounded-lg shadow-sm sm:flex sm:p-4 dark:bg-[#07457F] w-full" key={index}>
                              <div className="">
                                <h3 className="text-2xl font-normal text-gray-500 dark:text-gray-400">{ taskStatsConfig[task] }</h3>
                                <span className="text-xl font-bold text-gray-900 dark:text-white">{ taskStats[task] }</span>
                              </div>
                            </div>
                          )
                        })
                    }
                </div>
            </div>

            <div className="s12-p1-step border p-[5px] transition rounded-md my-[10px] md:w-2/3 lg:w-2/3 sm:w-full float-left">
                <div className="flex">
                  <Chart
                    chartType="PieChart"
                    data={pieChartData}
                    options={pieChartOptions}
                    width={"100%"}
                    height={"400px"}
                  />
                </div>
            </div>
        </div>
        <div className="flex flex-row">
            <div className="s12-p1-step border p-[5px] transition rounded-md my-[10px] w-full">
              <ReportTable data={reportList}/>
            </div>
        </div>
        </>
      )}
    </div>
  );
};

export default Reports;
